// API Base URLs and Endpoints
export const API_BASE_URLS = {
  // Helius Service API for user management and data storage
  HELIUS_SERVICE: process.env.REACT_APP_HELIUS_SERVICE_URL,

  // Gemini Generative Language API
  GENAI: process.env.REACT_APP_GEMINI_API_URL,

  // Local development API
  LOCAL_API: "http://localhost:5000/api/v1",
};

// API Endpoints
export const API_ENDPOINTS = {
  // Helius Service endpoints
  PATIENTS_LIST: `${API_BASE_URLS.HELIUS_SERVICE}/patients/list`,
  PATIENT_DETAILS: `${API_BASE_URLS.HELIUS_SERVICE}/patients`,
  SEND_PUSH_NOTIFICATION: `${API_BASE_URLS.HELIUS_SERVICE}/send-push-notification`,

  // Local API endpoints (for authentication)
  REGISTER: `${API_BASE_URLS.HELIUS_SERVICE}/register`,
  LOGIN: `${API_BASE_URLS.HELIUS_SERVICE}/login`,
  
  // Hospital management endpoints
  HOSPITALS_LIST: `${API_BASE_URLS.HELIUS_SERVICE}/hospitals`,
  ASSIGN_PATIENT: `${API_BASE_URLS.HELIUS_SERVICE}/patients`,
};

// Export individual URLs for convenience
export const {
  PATIENTS_LIST,
  PATIENT_DETAILS,
  SEND_PUSH_NOTIFICATION,
  REGISTER,
  LOGIN,
  HOSPITALS_LIST,
  ASSIGN_PATIENT,
} = API_ENDPOINTS;
